import React, { useEffect, useState } from 'react';
import { useLoaderData } from 'react-router-dom';
import Feature from './Feature';
import Gallery from './Gallery';
import Tools from './Tools';

const Project = () => {
    // const [project, setProject] = useState([])
    const project = useLoaderData();
    const { id, name, live_ink, git_clint_link, git_server_link, feature, tools, description, gallery } = project;
    console.log(name);


    return (
        <div className="md:w-3/5 w-full mx-auto bg-slate-200 p-10 rounded-xl my-8">
            <h2 className='md:text-5xl text-3xl text-center font-bold'>{name}</h2>
            <div className='flex flex-wrap gap-4 justify-center my-10 shadow-xl w-fit mx-auto p-4 bg-primary rounded-xl'>
                {
                    gallery.map((photo, i) => <Gallery
                        key={i}
                        photo={photo}
                    ></Gallery>)
                }
            </div>
            <div className="flex gap-4 justify-center">
                <a href={live_ink} target="_blank" className="btn bg-white border-0 text-neutral hover:bg-primary" rel="noReferrer">Live Site</a>
                <a href={git_clint_link} target="_blank" className="btn bg-white border-0 text-neutral hover:bg-primary" rel="noReferrer">Client Site Code</a>
                <a href={git_server_link} target="_blank" className="btn bg-white border-0 text-neutral hover:bg-primary" rel="noReferrer">Server Site Code</a>
            </div>

            <div className="my-4">
                <h2 className="text-3xl text-center text-primary">Features</h2>
                {
                    feature.map((allFeature, i) => <Feature
                        key={i}
                        allFeature={allFeature}
                    ></Feature>)
                }
            </div>
            <div className="my-4">
                <h2 className="text-3xl text-center text-primary">Tools</h2>
                {
                    tools.map((tool, i) => <Tools
                        key={i}
                        tool={tool}
                    ></Tools>)
                }
            </div>
        </div>
    );
};

export default Project;